import { designSystemConfig } from '@mentimeter/ragnar-dsc';
import { sand100, themes } from '@mentimeter/ragnar-colors';

export const DSC = {
  ...designSystemConfig,
  ...themes.light,
  boxShadow: {
    ...designSystemConfig.boxShadow,
    // https://www.figma.com/design/KoPZOC35m2MRXVHJgS4rkY/Menti-Web-Design-System?node-id=159-1518&p=f&m=dev
    far: '0 0 12px',
  },
  colors: {
    ...designSystemConfig.colors,
    bgElevated: sand100,
  },
  breakpoints: ['599px', '1135px', '1680px'],
  kosmosSpacing: {
    ...designSystemConfig.kosmosSpacing,
    // the following values are used for our custom content section verticalPadding
    'content-md-full': 88, //  (88px)
    'content-md-compressed': 64, //  (64px)
    'content-lg-full': 120, //  (120px)
    'content-lg-compressed': 80, //  (80px)
    'content-xl-full': 120, //  (120px)
    'content-xl-compressed': 80, //  (80px)
  },
  fontSizes: [
    // LEGACY: DON'T USE the font size by indices. The indices are incorrect.
    // Use kosmosFontSize intead e.g. fontSize={['112.5', '325]} etc
    10, // 0: text-62.5
    12, // 1: text-75
    14, // 2: text-87.5
    16, // 3: text-100
    18, // 4: text-112.5
    20, // 5: text-125
    24, // 6: text-150
    28, // 7: text-175
    32, // 8: text-200
    40, // 9: text-250
    48, // 10: text-300
    52, // 11: text-325 - contentHero4
    64, // 12: text-400
    68, // 13: text-425 - contentHero3
    80, // 14: text-500
    88, // 15: text-550 - contentHero2
    96, // 16: text-600
    104, // 17: text-650 NEW - contentNumberXL
    144, // 18  text-900 NEW - contentHero1
    176, // 29  text-1100 NEW - contentHero0
  ],

  kosmosFontSize: {
    ...designSystemConfig.kosmosFontSize,

    325: 52,
    550: 88,
    650: 104,
    750: 120,
    900: 144,
    1100: 176,
  },
};
